// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + "02c1f9d2aa571ab39bf0" + ".bundle.js";
};